import { msg } from "@lingui/core/macro";
import { createRoute, Outlet } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { useSession } from "@/lib/auth";
import { TodoListView } from "@/features/todos/components/todo-list-view";
import { getTodosCountQuery, getTodosQuery, nowISO } from "@listto/shared";
import { Calendar } from "@fleet/icons";

import type { PowerSyncDrizzleDB } from "@listto/powersync";
import { useI18n } from "@/providers/i18n-provider";

function PlannedPage() {
  const { t } = useI18n();
  const session = useSession();
  const { userId } = session;

  return (
    <>
      <TodoListView
        title={t(msg`Planned`)}
        icon={Calendar}
        userId={userId()}
        queryFn={(db: PowerSyncDrizzleDB, uid: string, options) =>
          getTodosQuery(db, uid, { ...options, plannedOnly: true })
        }
        countQueryFn={(db, uid) => getTodosCountQuery(db, uid, { plannedOnly: true })}
        defaultAddTodoProps={{ dueDate: nowISO() }}
        emptyMessage={t(msg`Plan your tasks by adding a due date.`)}
        listId="planned"
      />
      <Outlet />
    </>
  );
}

export const plannedRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/planned",
  component: PlannedPage,
});
